import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row, Image } from "react-bootstrap";
import {
  TextField,
  FormControl,
  InputLabel,
  makeStyles,
  OutlinedInput,
} from "@material-ui/core";
//import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

import { update_vendor_ticket_desc } from "../../../../../store/actions/VendorUsersTicketsActions/vendorUsersTicketsActions";
import { useFormik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { serverApi, videoUploadSize } from "../../../../../config/Keys";
import Alert from "react-s-alert";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const validationSchema = yup.object({
  description: yup
    .string()
    .required("Description  is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
});

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const EditOpenIssues = (props) => {
  const classes = useStyles();
  //state
  const [step, setStep] = useState(1);
  const [file, setFile] = useState(null);
  const [Video, setVideo] = useState(null);
  const [state, setState] = useState({
    category: "",
  });
  const handleStepChange = (e) => {
    setStep(e);
  };

  const uploadImage = (e) => {
    const data = new FormData();
    data.append("files", e.target.files[0]);
    //setFile(URL.createObjectURL(e.target.files[0]));

    axios
      .post(`${serverApi}/upload-assets?uploadSide=tickets`, data, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        setFile(res.data[0]);
        //formik.setFieldValue("photos", res.data[0]);
        formik.setFieldValue(`refrence_images[0]`, res.data[0]);
      })
      .catch((err) => {
        Alert.error(`<h4>Error while uploading  image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      });
  };

  const removeImage = () => {
    setFile(null);
    formik.setFieldValue("refrence_images", []);
  };

  const uploadVideo = (e) => {
    if (e.target.files) {
      if (e.target.files[0].size > videoUploadSize) {
        alert("File is too Big");
      } else {
        //setLoading(true);
        const data = new FormData();
        data.append("file", e.target.files[0]);
        axios
          .post(`${serverApi}/upload-assets-video`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            //setLoading(false);
            Alert.success(`<h4>Video uploaded sucessfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });

            setVideo(res.data[0]);
            //formik.setFieldValue("photos", res.data[0]);
            formik.setFieldValue(`refrence_videos[0]`, res.data[0]);
          })
          .catch((err) => {
            Alert.error(`<h4>Error while uploading the video</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          });
      }
    }
  };
  const removeVideo = () => {
    setVideo(null);
    formik.setFieldValue(`refrence_videos[0]`, "");
  };
  const [ShowEditIssue, setShowEditIssue] = useState(false);
  const handleShowEditIssue = () => {
    setShowEditIssue(true);
  };
  const handleCloseEditIssue = () => {
    setShowEditIssue(false);
  };

  const onSuccessEditTicket = () => {
    //props.updateLatest();
    handleCloseEditIssue();
  };

  const onErrorEditTicket = () => {
    setShowEditIssue(false);
  };

  const formik = useFormik({
    initialValues: {
      description: "",
      refrence_images: [],
      refrence_videos: [],
    },
    validationSchema,

    onSubmit: (values) => {
      const token = props.auth.user.accessToken;
      delete values["seating_request_no"];

      props.update_vendor_ticket_desc(
        values,
        token,
        props.issueDetail._id,
        onSuccessEditTicket,
        onErrorEditTicket
      );
    },
  });

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };
  useEffect(() => {
    if (formik.errors && formik.errors.description) {
      let descElement = document.getElementById("description");
      descElement.focus();
    }
  }, [count]);

  useEffect(() => {
    formik.setFieldValue(
      "seating_request_no",
      props.issueDetail.seating_request_no
    );
    formik.setFieldValue("description", props.issueDetail.description);
    setFile(props.issueDetail.refrence_images[0]);

    formik.setFieldValue(
      `refrence_images[0]`,
      props.issueDetail.refrence_images[0]
    );

    setVideo(props.issueDetail.refrence_videos[0]);

    formik.setFieldValue(
      `refrence_videos[0]`,
      props.issueDetail.refrence_videos[0]
    );
  }, []);
  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={handleShowEditIssue}
      >
        <Image
          src={require("../../../../../assets/images/UserManagement/pencil.svg")}
          alt="edit"
          title="edit"
          fluid
        />
      </Button>
      <Modal
        show={ShowEditIssue}
        onHide={handleCloseEditIssue}
        backdrop="static"
        keyboard={false}
        centered
        size="md"
      >
        <Modal.Header className="border-0 pb-0" closeButton>
          <Modal.Title className="f22-500">Edit a Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {step === 1 && (
            <Form>
              <Row>
                <Col md={5}>
                  <FormControl className={"w-100"} variant="outlined">
                    <InputLabel htmlFor="outlined-Mobile">Mobile No</InputLabel>
                    <OutlinedInput
                      disabled
                      value={
                        props &&
                        props.issueDetail &&
                        props.issueDetail.diner_id &&
                        props.issueDetail.diner_id.user_details.mobile_number
                      }
                      id="outlined-Mobile"
                      labelWidth={80}
                    />
                  </FormControl>
                </Col>
                <Col md={6} className="mobile-mt-4">
                  <Form.Group>
                    <TextField
                      disabled
                      variant="outlined"
                      label="Name"
                      className="w-100"
                      value={
                        props &&
                        props.issueDetail &&
                        props.issueDetail.diner_id &&
                        props.issueDetail.diner_id.user_details.name
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Label className="f12-500 pb-3">Select Type</Form.Label>
                  <Row className="enSelectTypeIssue">
                    <Col xs={4}>
                      <div className="enCheckWithText ">
                        <input type="radio" defaultChecked name="enIssueType" />
                        <label>Seating</label>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="enCheckWithText ">
                        <input type="radio" name="enIssueType" />
                        <label>Scan & Pay</label>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="enCheckWithText ">
                        <input type="radio" name="enIssueType" />
                        <label>Ordering</label>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="enCheckWithText ">
                        <input type="radio" name="enIssueType" />
                        <label>Offers</label>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="enCheckWithText ">
                        <input type="radio" name="enIssueType" />
                        <label>Wallet</label>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="enCheckWithText ">
                        <input type="radio" name="enIssueType" />
                        <label>Technical</label>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="enCheckWithText ">
                        <input type="radio" name="enIssueType" />
                        <label>Events</label>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="enCheckWithText ">
                        <input type="radio" name="enIssueType" />
                        <label>Referral</label>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="enCheckWithText ">
                        <input type="radio" name="enIssueType" />
                        <label className="">Rating & Review</label>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="enCheckWithText ">
                        <input type="radio" name="enIssueType" />
                        <label>General/Other</label>
                      </div>
                    </Col>
                    <Col xs={4}>
                      <div className="enCheckWithText ">
                        <input type="radio" name="enIssueType" />
                        <label>Other Payment</label>
                      </div>
                    </Col>
                  </Row>
                  <div className="pt-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 "
                      onClick={handleCloseEditIssue}
                    >
                      Back
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5"
                      onClick={(e) => handleStepChange(2)}
                    >
                      Next
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
          {step === 2 && (
            <Form>
              <Row>
                <Col md={12}>
                  <div className="f12-400 opacity5 mb-3">
                    Please select the type of ticket first to continue
                  </div>
                  <Form.Group>
                    <TextField
                      value="Seating"
                      disabled
                      variant="outlined"
                      label="Issue Type"
                      className="w-100"
                    />
                  </Form.Group>
                  <Form.Group>
                    {/* <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel htmlFor="outlined-Issue-Category">
                        Issue Category
                      </InputLabel>
                      <Select
                        value={state.category}
                        onChange={handleChangeCode}
                        label="Issue Category"
                        inputProps={{
                          name: "category",
                          id: "outlined-Issue-Category",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <option value={"Other"}>Other</option>
                      </Select>
                    </FormControl> */}
                  </Form.Group>
                  <Form.Group>
                    <TextField
                      disabled
                      value={formik.values.seating_request_no}
                      variant="outlined"
                      label="Request Number"
                      className="w-100"
                    />
                  </Form.Group>
                  <Form.Group>
                    <TextField
                      id="description"
                      variant="outlined"
                      label="Issue Details"
                      multiline
                      rows="5"
                      className={`w-100 p-1 ${
                        formik.errors.description && formik.touched.description
                          ? "enError"
                          : ""
                      }`}
                      name="description"
                      onChange={formik.handleChange}
                      value={formik.values.description}
                      onBlur={formik.handleBlur}
                      //onInvalid={formik.errors.email && formik.touched.email}
                      isInvalid={
                        formik.errors.description && formik.touched.description
                      }
                    />
                    {formik.errors.description && formik.touched.description ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.description}
                      </div>
                    ) : null}
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="f14-500">Upload Photos</Form.Label>
                    <div className="d-flex flex-wrap">
                      <div className="enUploadBox">
                        <Image
                          src={require("../../../../../assets/images/UserManagement/uploadImg.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                        <input
                          type="file"
                          accept=".png, .jpg, .jpeg"
                          onChange={(e) => uploadImage(e)}
                        />
                      </div>
                      {file && (
                        <div className="enIconUploaded">
                          <button
                            type="button"
                            className="enCloseButton"
                            onClick={() => removeImage()}
                          >
                            <Image
                              src={require("../../../../../assets/images/UserManagement/en_close.svg")}
                              alt="uploadImg"
                              title="uploadImg"
                              fluid
                            />
                          </button>
                          <Image
                            src={file}
                            alt="icon"
                            title="icon"
                            className=""
                            fluid
                          />
                        </div>
                      )}
                    </div>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label className="f14-500">Upload Videos</Form.Label>
                    <div className="d-flex flex-wrap">
                      <div className="enUploadBox">
                        <Image
                          src={require("../../../../../assets/images/UserManagement/uploadImg.svg")}
                          alt="uploadImg"
                          title="uploadImg"
                          fluid
                        />
                        <input
                          type="file"
                          accept=".mp4"
                          onChange={uploadVideo}
                        />
                      </div>
                      {Video && (
                        <div className="enIconUploaded">
                          <button
                            type="button"
                            className="enCloseButton"
                            onClick={() => removeVideo()}
                          >
                            <Image
                              src={require("../../../../../assets/images/UserManagement/en_close.svg")}
                              alt="uploadImg"
                              title="uploadImg"
                              fluid
                            />
                          </button>
                          <video
                            width="100%"
                            height="100%"
                            controls
                            src={Video}
                            type="video/mp4"
                          />
                        </div>
                      )}
                    </div>
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <div className="pt-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 "
                      onClick={(e) => handleStepChange(1)}
                    >
                      Back
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5"
                      onClick={() => onClickSave()}
                    >
                      Save
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

EditOpenIssues.propTypes = {
  auth: PropTypes.object.isRequired,
  update_vendor_ticket_desc: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  update_vendor_ticket_desc,
})(EditOpenIssues);
